import Icon from '../components/Icon.vue'

Icon.register({
  hamsa: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M509.3 307.3c1.5 3.4 2.7 9.1 2.7 12.8 0 7-3.9 16.7-8.6 21.8l-102.7 110c-35.7 38.2-88.4 60.1-144.7 60.1s-109-21.9-144.7-60.1l-102.7-110c-4.7-5.1-8.6-14.9-8.6-21.8 0-3.7 1.2-9.4 2.7-12.8 5.1-11.7 16.6-19.3 29.3-19.3h64v-208c0-22 18-40 40-40s40 18 40 40v134c0 5.5 4.5 10 10 10h20c5.5 0 10-4.5 10-10v-174c0-22 18-40 40-40s40 18 40 40v174c0 5.5 4.5 10 10 10h20c5.5 0 10-4.5 10-10v-134c0-22 18-40 40-40s40 18 40 40v208h64c12.8 0 24.3 7.6 29.3 19.3zM256 416c53 0 96-64 96-64s-43-64-96-64-96 64-96 64 43 64 96 64zM256 320c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hamsa.js
// module id = 1423
// module chunks = 0